import { useTheme } from "next-themes"
import { useEffect, useState } from "react"
import { Switch } from "@/components/ui/switch"

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Ensure component only renders after client mount
  useEffect(() => setMounted(true), [])

  if (!mounted) return null

  // Use `resolvedTheme` to get actual theme ('light' or 'dark')
  const isDark = resolvedTheme === "dark"

  return (
    <Switch
      checked={isDark}
      onCheckedChange={(checked) =>
        setTheme(checked ? "dark" : "light")
      }
      aria-label="Toggle theme"
    />
  )
}
